var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c("router-view"),
      _vm._v(" "),
      _c("alert-component", {
        attrs: {
          message: _vm.$store.getters["app/GET_ALERT"].message,
          callback: _vm.$store.getters["app/GET_ALERT"].callback,
        },
        model: {
          value: _vm.$store.getters["app/GET_ALERT"].value,
          callback: function ($$v) {
            _vm.$set(_vm.$store.getters["app/GET_ALERT"], "value", $$v)
          },
          expression: "$store.getters['app/GET_ALERT'].value",
        },
      }),
      _vm._v(" "),
      _c("confirm-component", {
        attrs: {
          message: _vm.$store.getters["app/GET_CONFIRM"].message,
          oktext: _vm.$store.getters["app/GET_CONFIRM"].oktext,
          canceltext: _vm.$store.getters["app/GET_CONFIRM"].canceltext,
          callback: _vm.$store.getters["app/GET_CONFIRM"].callback,
        },
        model: {
          value: _vm.$store.getters["app/GET_CONFIRM"].value,
          callback: function ($$v) {
            _vm.$set(_vm.$store.getters["app/GET_CONFIRM"], "value", $$v)
          },
          expression: "$store.getters['app/GET_CONFIRM'].value",
        },
      }),
      _vm._v(" "),
      _c(
        "v-overlay",
        {
          attrs: {
            "z-index": _vm.$store.state.app.loading.zIndex,
            value: _vm.$store.state.app.loading.overlay,
          },
        },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "128" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }